import { Stack } from '@mui/material';
import { NewLogo, NewLogoMobile } from 'Images';
import { LogoButton } from './LogoButton';
import { useIsDesktop } from 'Hooks';

export const LogoButtons = () => {
  const isDesktop = useIsDesktop();

  return (
    <Stack width='fit-content' direction='row' alignItems='center'>
      <LogoButton
        logo={isDesktop ? NewLogo : NewLogoMobile}
        href={`${import.meta.env.VITE_APP_MARKETING_SITE_URL}`}
        ariaLabel='Logo'
        isDesktop={isDesktop}
      />
    </Stack>
  );
};
